import {z} from 'zod';
import {id, nonNegativeInt} from '../global/globalModels';
import {bookingUserModel} from './bookingUserModel';

const resourceUsageAvailability = z.union([
    z.literal('available'),
    z.literal('partiallyOccupied'),
    z.literal('occupied'),
    z.literal('outOfBounds'),
    z.literal('blocked'),
    z.literal('notAllowed'),
    z.literal('restricted'),
    z.literal('reserved'),
    z.literal('prioritized'),
]);

export type ResourceUsageAvailability = z.infer<typeof resourceUsageAvailability>;

export const resourceUsageModel = z.object({
    anonymousUser: z.number(),
    bookedBySelf: z.boolean(),
    resource: id,
    availability: resourceUsageAvailability,
    occupiedBy: bookingUserModel.array(),
    bookedCapacity: nonNegativeInt.optional(),
    totalUsers: nonNegativeInt,
    characteristics: z.array(id).optional(),
    resourceName: z.string().optional(),
    room: id.optional(),
    priority: z.boolean(),
});

export type ResourceUsageModel = z.infer<typeof resourceUsageModel>;

export const resourceUsageListModel = z.object({
    resourceType: id,
    totalCount: z.number(),
    resourceUsages: resourceUsageModel.array(),
});

export type ResourceUsageListModel = z.infer<typeof resourceUsageListModel>;
